import React, { useState } from 'react';
import { IntelyxLogo } from './IntelyxLogo';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsOfUseModal } from './TermsOfUseModal';
import { CookiePolicyModal } from './CookiePolicyModal';
import './Footer.css';

export const Footer: React.FC = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);

  const handleNavigation = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openPrivacyModal = () => {
    setIsPrivacyModalOpen(true);
  };

  const closePrivacyModal = () => {
    setIsPrivacyModalOpen(false);
  };

  const openTermsModal = () => {
    setIsTermsModalOpen(true);
  };

  const closeTermsModal = () => {
    setIsTermsModalOpen(false);
  };

  const openCookieModal = () => {
    setIsCookieModalOpen(true);
  };

  const closeCookieModal = () => {
    setIsCookieModalOpen(false);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon">
                <IntelyxLogo width={36} height={36} />
              </div>
              <span className="logo-text">Intelyx AI</span>
            </div>
            <p className="footer-description">
              Empowering sales and marketing teams with precise recommendations 
              designed to accelerate conversions.
            </p>
            <div className="social-links">
              <a href="#" className="social-link">
                <svg width="20" height="20" fill="#3ab7c3" viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              <a href="#" className="social-link">
                <svg width="20" height="20" fill="#3ab7c3" viewBox="0 0 24 24">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">Products</h4>
              <ul className="footer-link-list">
                <li>
                  <a href="#products" className="footer-link footer-product-link" onClick={(e) => { e.preventDefault(); handleNavigation('products'); }}>
                    <span className="spotton-brand-text">Spott-on</span>
                    <span className="footer-product-tier">Professional</span>
                  </a>
                </li>
                <li>
                  <a href="#products" className="footer-link footer-product-link" onClick={(e) => { e.preventDefault(); handleNavigation('products'); }}>
                    <span className="spotton-brand-text">Spott-on</span>
                    <span className="footer-product-tier">Elite</span>
                  </a>
                </li>
                <li>
                  <a href="#products" className="footer-link footer-product-link" onClick={(e) => { e.preventDefault(); handleNavigation('products'); }}>
                    <span className="spotton-brand-text">Spott-on</span>
                    <span className="footer-product-tier">Enterprise</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Company</h4>
              <ul className="footer-link-list">
                <li><a href="#about" className="footer-link" onClick={(e) => { e.preventDefault(); handleNavigation('about'); }}>About Us</a></li>
                <li><a href="#contact" className="footer-link" onClick={(e) => { e.preventDefault(); handleNavigation('contact'); }}>Contact</a></li>
                <li><a href="#contact" className="footer-link" onClick={(e) => { e.preventDefault(); handleNavigation('contact'); }}>Support</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p>&copy; 2025 Intelyx AI. All rights reserved.</p>
          </div>
          <div className="footer-bottom-right">
            <button 
              onClick={openPrivacyModal}
              className="footer-legal-link footer-legal-button"
            >
              Privacy Policy
            </button>
            <button 
              onClick={openTermsModal}
              className="footer-legal-link footer-legal-button"
            >
              Terms of Service
            </button>
            <button 
              onClick={openCookieModal}
              className="footer-legal-link footer-legal-button"
            >
              Cookie Policy
            </button>
          </div>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal 
        isOpen={isPrivacyModalOpen} 
        onClose={closePrivacyModal} 
      />

      {/* Terms of Use Modal */}
      <TermsOfUseModal 
        isOpen={isTermsModalOpen} 
        onClose={closeTermsModal} 
      />

      {/* Cookie Policy Modal */}
      <CookiePolicyModal 
        isOpen={isCookieModalOpen} 
        onClose={closeCookieModal} 
      />
    </footer>
  );
};